'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Logrocket = require("logrocket");
var Caml_format = require("rescript/lib/js/caml_format.js");
var RescriptReactRouter = require("@rescript/react/lib/js/src/RescriptReactRouter.js");
var Nav$PvpcontrollerWeb = require("./components/Nav.js");
var Armor$PvpcontrollerWeb = require("./components/Armor.js");
var Weapon$PvpcontrollerWeb = require("./components/Weapon.js");
var Loading$PvpcontrollerWeb = require("./components/Loading.js");
var Weapons$PvpcontrollerWeb = require("./components/Weapons.js");
var Redirect$PvpcontrollerWeb = require("./components/Redirect.js");
var Settings$PvpcontrollerWeb = require("./components/Settings.js");
var Dashboard$PvpcontrollerWeb = require("./components/Dashboard.js");
var Debugging$PvpcontrollerWeb = require("./Debugging.js");
var ArmorPiece$PvpcontrollerWeb = require("./components/ArmorPiece.js");
var Projectile$PvpcontrollerWeb = require("./components/Projectile.js");
var Projectiles$PvpcontrollerWeb = require("./components/Projectiles.js");
var ChangelogPage$PvpcontrollerWeb = require("./components/ChangelogPage.js");
var CookieService$PvpcontrollerWeb = require("./services/CookieService.js");
var EditModeAlert$PvpcontrollerWeb = require("./components/EditModeAlert.js");
var AccountService$PvpcontrollerWeb = require("./services/AccountService.js");
var EditModeReview$PvpcontrollerWeb = require("./components/EditModeReview.js");
var EditModeService$PvpcontrollerWeb = require("./services/EditModeService.js");

var scrollbarWidth = {
  NAME: "calc",
  VAL: [
    "sub",
    {
      NAME: "percent",
      VAL: 100.0
    },
    {
      NAME: "vw",
      VAL: 100.0
    }
  ]
};

var app = Curry._1(Css.style, {
      hd: Css.marginRight(scrollbarWidth),
      tl: {
        hd: Css.paddingRight(scrollbarWidth),
        tl: {
          hd: Css.height({
                NAME: "percent",
                VAL: 100
              }),
          tl: /* [] */0
        }
      }
    });

var content = Curry._1(Css.style, {
      hd: Css.paddingLeft(Css.px(20)),
      tl: {
        hd: Css.paddingRight(Css.px(20)),
        tl: {
          hd: Css.maxWidth(Css.px(1300)),
          tl: {
            hd: Css.margin(Css.auto),
            tl: {
              hd: Css.marginBottom(Css.px(20)),
              tl: /* [] */0
            }
          }
        }
      }
    });

function App(Props) {
  var match = React.useState(function () {
        return {
                TAG: /* VerifyingSession */0,
                _0: /* Unknown */0
              };
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return /* Unknown */0;
      });
  var setWantedEditModeState = match$1[1];
  var wantedEditModeState = match$1[0];
  var match$2 = React.useState(function () {
        return /* WaitingOnTimer */0;
      });
  var setBackgroundSyncState = match$2[1];
  var backgroundSyncState = match$2[0];
  React.useEffect((function () {
          if (state.TAG !== /* VerifyingSession */0) {
            return ;
          }
          var cookies = CookieService$PvpcontrollerWeb.getSessionCookies(undefined);
          if (cookies !== undefined) {
            var sessionId = cookies.sessionId;
            var token = cookies.token;
            return AccountService$PvpcontrollerWeb.verify(sessionId, token, (function (result) {
                          if (result.TAG === /* Ok */0) {
                            var verified = result._0;
                            return Curry._1(setState, (function (previousState) {
                                          var editMode;
                                          editMode = previousState.TAG === /* VerifyingSession */0 ? previousState._0 : previousState._1;
                                          if (typeof verified === "number") {
                                            Debugging$PvpcontrollerWeb.info("NotVerified");
                                            return {
                                                    TAG: /* Normal */1,
                                                    _0: "NotVerified",
                                                    _1: /* Disabled */2
                                                  };
                                          }
                                          if (verified.TAG === /* Verified */0) {
                                            Debugging$PvpcontrollerWeb.info("Verified");
                                            return {
                                                    TAG: /* Normal */1,
                                                    _0: {
                                                      NAME: "Verified",
                                                      VAL: {
                                                        id: sessionId,
                                                        token: token,
                                                        userId: verified._0,
                                                        avatar: verified._2,
                                                        username: verified._1
                                                      }
                                                    },
                                                    _1: editMode
                                                  };
                                          }
                                          Debugging$PvpcontrollerWeb.info("VerifiedNoManage");
                                          return {
                                                  TAG: /* Normal */1,
                                                  _0: {
                                                    NAME: "VerifiedNoManage",
                                                    VAL: {
                                                      id: sessionId,
                                                      token: token,
                                                      userId: verified._0,
                                                      avatar: verified._2,
                                                      username: verified._1
                                                    }
                                                  },
                                                  _1: /* Disabled */2
                                                };
                                        }));
                          }
                          Curry._1(setState, (function (previousState) {
                                  if (previousState.TAG === /* VerifyingSession */0) {
                                    return {
                                            TAG: /* Normal */1,
                                            _0: "NotVerified",
                                            _1: previousState._0
                                          };
                                  } else {
                                    return {
                                            TAG: /* Normal */1,
                                            _0: "NotVerified",
                                            _1: previousState._1
                                          };
                                  }
                                }));
                          return Debugging$PvpcontrollerWeb.info("Bad cookies");
                        }));
          }
          Curry._1(setState, (function (previousState) {
                  if (previousState.TAG === /* VerifyingSession */0) {
                    return {
                            TAG: /* Normal */1,
                            _0: "NotVerified",
                            _1: previousState._0
                          };
                  } else {
                    return {
                            TAG: /* Normal */1,
                            _0: "NotVerified",
                            _1: previousState._1
                          };
                  }
                }));
          Debugging$PvpcontrollerWeb.info("No cookies found");
          
        }), []);
  React.useEffect((function () {
          if (state.TAG !== /* VerifyingSession */0) {
            var match = state._0;
            if (typeof match === "object") {
              var match$1 = match.VAL;
              Logrocket.identify(String(match$1.userId), {
                    name: match$1.username
                  });
            }
            
          }
          
        }), [state]);
  React.useEffect((function () {
          if (backgroundSyncState) {
            if (state.TAG === /* VerifyingSession */0) {
              return ;
            }
            var match = state._0;
            if (typeof match === "object" && match.NAME === "Verified") {
              Debugging$PvpcontrollerWeb.info("Sync edit mode");
              return EditModeService$PvpcontrollerWeb.getEditModeState(function (result) {
                          if (result.TAG === /* Ok */0) {
                            var newEditModeState = result._0.enabled ? /* Enabled */1 : /* Disabled */2;
                            Curry._1(setState, (function (previousState) {
                                    if (previousState.TAG === /* VerifyingSession */0) {
                                      return {
                                              TAG: /* VerifyingSession */0,
                                              _0: newEditModeState
                                            };
                                    }
                                    var session = previousState._0;
                                    if (typeof session === "object" && session.NAME !== "VerifiedNoManage") {
                                      return {
                                              TAG: /* Normal */1,
                                              _0: session,
                                              _1: newEditModeState
                                            };
                                    } else {
                                      return {
                                              TAG: /* Normal */1,
                                              _0: session,
                                              _1: /* Disabled */2
                                            };
                                    }
                                  }));
                            return Curry._1(setBackgroundSyncState, (function (_previousState) {
                                          return /* WaitingOnTimer */0;
                                        }));
                          }
                          Debugging$PvpcontrollerWeb.messageWithData("App-PvpcontrollerWeb:getEditModeState Could not get edit mode state.", {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: result._0
                              });
                          return Curry._1(setBackgroundSyncState, (function (_previousState) {
                                        return /* WaitingOnTimer */0;
                                      }));
                        });
            } else {
              return ;
            }
          }
          Debugging$PvpcontrollerWeb.info("Timer");
          var timer = setTimeout((function (param) {
                  return Curry._1(setBackgroundSyncState, (function (_previousState) {
                                return /* WaitingOnRequest */1;
                              }));
                }), 15000);
          return (function (param) {
                    clearTimeout(timer);
                    
                  });
        }), [backgroundSyncState]);
  React.useEffect((function () {
          return EditModeService$PvpcontrollerWeb.getEditModeState(function (result) {
                      if (result.TAG !== /* Ok */0) {
                        return Debugging$PvpcontrollerWeb.messageWithData("App-PvpcontrollerWeb:getEditModeState Could not get edit mode state.", {
                                    tags: (function (prim) {
                                        return {};
                                      }),
                                    extra: result._0
                                  });
                      }
                      var newEditModeState = result._0.enabled ? /* Enabled */1 : /* Disabled */2;
                      return Curry._1(setState, (function (previousState) {
                                    if (previousState.TAG === /* VerifyingSession */0) {
                                      return {
                                              TAG: /* VerifyingSession */0,
                                              _0: newEditModeState
                                            };
                                    }
                                    var session = previousState._0;
                                    if (typeof session === "object" && session.NAME !== "VerifiedNoManage") {
                                      return {
                                              TAG: /* Normal */1,
                                              _0: session,
                                              _1: newEditModeState
                                            };
                                    } else {
                                      return {
                                              TAG: /* Normal */1,
                                              _0: session,
                                              _1: /* Disabled */2
                                            };
                                    }
                                  }));
                    });
        }), []);
  React.useEffect((function () {
          if (state.TAG === /* VerifyingSession */0) {
            return ;
          }
          var session = state._0;
          if (typeof session !== "object") {
            return ;
          }
          if (session.NAME === "VerifiedNoManage") {
            return ;
          }
          Curry._1(setState, (function (_previousState) {
                  return {
                          TAG: /* Normal */1,
                          _0: session,
                          _1: /* Unknown */0
                        };
                }));
          switch (wantedEditModeState) {
            case /* Unknown */0 :
                return ;
            case /* Enabled */1 :
                return EditModeService$PvpcontrollerWeb.setEditModeState(session, true, (function (result) {
                              Debugging$PvpcontrollerWeb.info("Enabling");
                              if (result.TAG === /* Ok */0) {
                                return Curry._1(setState, (function (previousState) {
                                              if (previousState.TAG === /* VerifyingSession */0) {
                                                return previousState;
                                              }
                                              Debugging$PvpcontrollerWeb.info("Enabled");
                                              return {
                                                      TAG: /* Normal */1,
                                                      _0: previousState._0,
                                                      _1: /* Enabled */1
                                                    };
                                            }));
                              } else {
                                return Debugging$PvpcontrollerWeb.messageWithData("App-PvpcontrollerWeb:setEditModeState Could not enable edit mode.", {
                                            tags: (function (prim) {
                                                return {};
                                              }),
                                            extra: result._0
                                          });
                              }
                            }));
            case /* Disabled */2 :
                return EditModeService$PvpcontrollerWeb.setEditModeState(session, false, (function (result) {
                              if (result.TAG !== /* Ok */0) {
                                return Debugging$PvpcontrollerWeb.messageWithData("App-PvpcontrollerWeb:setEditModeState Could not disable edit mode.", {
                                            tags: (function (prim) {
                                                return {};
                                              }),
                                            extra: result._0
                                          });
                              }
                              var match = result._0.status;
                              if (match === 200) {
                                return Curry._1(setState, (function (previousState) {
                                              if (previousState.TAG === /* VerifyingSession */0) {
                                                return previousState;
                                              } else {
                                                return {
                                                        TAG: /* Normal */1,
                                                        _0: previousState._0,
                                                        _1: /* Disabled */2
                                                      };
                                              }
                                            }));
                              }
                              match !== 409;
                              Curry._1(setState, (function (previousState) {
                                      if (previousState.TAG === /* VerifyingSession */0) {
                                        return previousState;
                                      } else {
                                        return {
                                                TAG: /* Normal */1,
                                                _0: previousState._0,
                                                _1: /* Enabled */1
                                              };
                                      }
                                    }));
                              Curry._1(setWantedEditModeState, (function (_previousState) {
                                      return /* Enabled */1;
                                    }));
                              return Debugging$PvpcontrollerWeb.info("Tried to disable Edit mode when there are changes");
                            }));
            
          }
        }), [wantedEditModeState]);
  var path = RescriptReactRouter.useUrl(undefined, undefined).path;
  var page = Belt_List.head(path);
  var tmp;
  if (state.TAG === /* VerifyingSession */0) {
    tmp = React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps(undefined, "Verifying session details...", true, undefined, undefined, undefined, undefined, undefined));
  } else {
    var editMode = state._1;
    var session = state._0;
    var tmp$1;
    tmp$1 = typeof session === "object" && !(session.NAME === "VerifiedNoManage" || editMode !== 1 || page === "editmodereview") ? React.createElement(EditModeAlert$PvpcontrollerWeb.make, EditModeAlert$PvpcontrollerWeb.makeProps(undefined, undefined)) : React.createElement(React.Fragment, undefined);
    var tmp$2;
    var exit = 0;
    if (path) {
      switch (path.hd) {
        case "armor" :
            tmp$2 = React.createElement(Armor$PvpcontrollerWeb.make, Armor$PvpcontrollerWeb.makeProps(undefined, undefined));
            break;
        case "armorPiece" :
            var match$3 = path.tl;
            if (match$3 && !match$3.tl) {
              tmp$2 = React.createElement(ArmorPiece$PvpcontrollerWeb.make, ArmorPiece$PvpcontrollerWeb.makeProps(Caml_format.caml_int_of_string(match$3.hd), editMode, session, undefined, undefined));
            } else {
              exit = 1;
            }
            break;
        case "changelog" :
            if (path.tl) {
              exit = 1;
            } else {
              tmp$2 = React.createElement(ChangelogPage$PvpcontrollerWeb.make, ChangelogPage$PvpcontrollerWeb.makeProps(undefined, undefined));
            }
            break;
        case "editmodereview" :
            if (path.tl) {
              exit = 1;
            } else {
              var exit$1 = 0;
              if (typeof session === "object" && session.NAME === "Verified" && editMode < 2) {
                tmp$2 = React.createElement(EditModeReview$PvpcontrollerWeb.make, EditModeReview$PvpcontrollerWeb.makeProps(session, setWantedEditModeState, editMode, undefined, undefined));
              } else {
                exit$1 = 2;
              }
              if (exit$1 === 2) {
                tmp$2 = React.createElement(Redirect$PvpcontrollerWeb.make, Redirect$PvpcontrollerWeb.makeProps("/dashboard", undefined, undefined));
              }
              
            }
            break;
        case "projectile" :
            var match$4 = path.tl;
            if (match$4 && !match$4.tl) {
              tmp$2 = React.createElement(Projectile$PvpcontrollerWeb.make, Projectile$PvpcontrollerWeb.makeProps(Caml_format.caml_int_of_string(match$4.hd), editMode, session, undefined, undefined));
            } else {
              exit = 1;
            }
            break;
        case "projectiles" :
            tmp$2 = React.createElement(Projectiles$PvpcontrollerWeb.make, Projectiles$PvpcontrollerWeb.makeProps(undefined, undefined));
            break;
        case "settings" :
            if (path.tl) {
              exit = 1;
            } else {
              tmp$2 = React.createElement(Settings$PvpcontrollerWeb.make, Settings$PvpcontrollerWeb.makeProps(editMode, session, undefined, undefined));
            }
            break;
        case "weapon" :
            var match$5 = path.tl;
            if (match$5 && !match$5.tl) {
              tmp$2 = React.createElement(Weapon$PvpcontrollerWeb.make, Weapon$PvpcontrollerWeb.makeProps(Caml_format.caml_int_of_string(match$5.hd), editMode, session, undefined, undefined));
            } else {
              exit = 1;
            }
            break;
        case "weapons" :
            tmp$2 = React.createElement(Weapons$PvpcontrollerWeb.make, Weapons$PvpcontrollerWeb.makeProps(undefined, undefined));
            break;
        default:
          exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      tmp$2 = React.createElement(Dashboard$PvpcontrollerWeb.make, Dashboard$PvpcontrollerWeb.makeProps(undefined, undefined));
    }
    tmp = [
      React.createElement(Nav$PvpcontrollerWeb.make, Nav$PvpcontrollerWeb.makeProps(session, editMode, setWantedEditModeState, "nav", undefined)),
      React.createElement("div", {
            key: "content",
            className: content
          }, tmp$1, tmp$2)
    ];
  }
  return React.createElement("div", {
              className: app
            }, tmp);
}

function makeProps(prim0, prim1) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.key = prim0;
  }
  return tmp;
}

var make = App;

exports.makeProps = makeProps;
exports.make = make;
/* app Not a pure module */
